import { ComplianceExternalObjectType } from "~/graphql/supergraphEnums";
import { type ExternalObjectInput } from "~/graphql/supergraphTypes";
import { MAIN_SERVICE } from "~/pages/Compliance/utils/constants";
import { toExternalObjectId } from "./toExternalObjectId";
import type { OnboardingCaseType } from "../types";

type BuildArgs = {
  subjectKind: OnboardingCaseType;
  entityId?: string;
  entityName?: string;
  clientId?: string;
  clientName?: string;
};

export const buildLinkExternalObject = ({
  subjectKind,
  entityId,
  entityName,
  clientId,
  clientName,
}: BuildArgs): ExternalObjectInput | null => {
  if (subjectKind === "entity") {
    if (!entityId) return null;
    return {
      objectId: toExternalObjectId(entityId),
      objectTypeEnum: ComplianceExternalObjectType.Account,
      service: MAIN_SERVICE,
      name: entityName ?? "",
    };
  }
  if (!clientId) return null;
  return {
    objectId: toExternalObjectId(clientId),
    objectTypeEnum: ComplianceExternalObjectType.Arena,
    service: MAIN_SERVICE,
    name: clientName ?? "",
  };
};
